import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonIsonKentimata';
const args = {};

export class OligonIsonKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
